exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-enter-active, .form-leave-active {\n    transition: all 0.35s;\n}\n.form-enter, .form-leave-to {\n    opacity: 0;\n}\n\n", ""]);

// exports
